import { Flex, HStack, Text } from "@chakra-ui/react"
import { useState } from "react"
import { Link } from "react-scroll"

export const Header = () => {
    
    const [headerColor, setHeaderColor] = useState(false)

    const isScrolling = () => {
        const scrollY = window.scrollY

        if (scrollY > 100) {
            setHeaderColor(true)

        } else {
            setHeaderColor(false)
        }
    }
    window.addEventListener("scroll", isScrolling )

    return(
        <Flex
            w="100%"
            h="70px"
            bg={headerColor ? "blue.400": "blue.300"}
            alignItems="center"
            justifyContent="flex-end"
            position="fixed"
            zIndex="2"
        >   
            <HStack mr="8%">
                <Text 
                    cursor="pointer"
                    mr="4"  
                    _hover={{color:"gray.300"}}
                    >
                        <Link 
                            textDecoration="none"
                            to="projects"
                            smooth={ true }
                            duration={ 1000 }
                        >Trabalhos
                            
                        </Link>
                </Text>
                <Text 
                    cursor="pointer"
                    _hover={{color:"gray.300"}}
                >
                    <Link 
                        to="about"
                        smooth={ true }
                        duration={ 1000 }
                        >Sobre
                    </Link>
                </Text>
            </HStack>
        </Flex>
    )
}